/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';
/**
 * Check if a given object implements the Contact interface.
 */
export function instanceOfContact(value) {
    let isInstance = true;
    return isInstance;
}
export function ContactFromJSON(json) {
    return ContactFromJSONTyped(json, false);
}
export function ContactFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}
export function ContactToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'phoneNumber': value.phoneNumber,
        'email': value.email,
    };
}
